import "react-toastify/dist/ReactToastify.css";

import { Amplify } from "aws-amplify";
import { ContextGlobal } from "./context/global";
import EnvironmentWatermark from "./components/environmentWatermark";
import ErrorBoundary from "./components/errorBoundary";
import GlobalStyle from "./theme/globalStyles";
import MyTheme from "./theme/myTheme";
import Routes from "./routes";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import aws_exports from "./aws-exports";
import { documentTitle } from "./utils/environment";
import { useEffect } from "react";

Amplify.configure(aws_exports);

export default function App() {
    useEffect(() => {
        document.title = documentTitle;
    }, []);

    return (
        <>
            <ThemeProvider theme={MyTheme}>
                <GlobalStyle />
                {/* Rede de segurança final: pega erros fora do boundary por-rota
                    (Layout, contexto global, router) que de outra forma deixariam
                    a aplicação inteira em branco. */}
                <ErrorBoundary>
                    <ContextGlobal>
                        <Routes />
                    </ContextGlobal>
                </ErrorBoundary>
                <ToastContainer autoClose={5000} position="top-center" />
                <EnvironmentWatermark />
            </ThemeProvider>
        </>
    );
}
